var map = {
	"./bounce/blocks": 2463,
	"./calc/blocks": 2464,
	"./craft/agent/blocks": 2466,
	"./craft/code-connection/blocks": 2467,
	"./craft/designer/blocks": 2262,
	"./craft/simple/blocks": 2465,
	"./dance/blocks": 1764,
	"./eval/blocks": 2468,
	"./flappy/blocks": 2469,
	"./jigsaw/blocks": 2475,
	"./maze/blocks": 2508,
	"./p5lab/spritelab/blocks": 1627,
	"./sites/studio/pages/blocks": 2520,
	"./studio/blocks": 2266,
	"./turtle/blocks": 2515
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2932;